import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../config/FirebaseConfig"; // Import the Firebase setup
import { checkDB, getUserDataById } from "./DataFunctions";

// Save user data to Firestore
export async function saveUser(userData) {
  const userDocRef = doc(db, "user", userData.id);
  await setDoc(userDocRef, {
    display_name: userData.display_name,
    email: userData.email,
    org_id: userData.org_id,
    admin: userData.admin,
    ref: userDocRef, // Include the reference when saving the data
  });
}

// Fetch a user document from Firestore by reference
export async function getUserByRef(userRef) {
  const userSnapshot = await getDoc(checkDB(userRef));
  if (userSnapshot.exists()) {
    return { id: userRef.id, ref: userRef, ...userSnapshot.data() }; // Include the reference and ID in the returned data
  } else {
    console.warn("No user with that reference");
    return null;
  }
}

// Fetch a user document from Firestore by ID
export async function getUserById(userId) {
  return getUserDataById(userId);
}
